var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _vm.loading_folders
        ? _vm._l(3, function (i, index) {
            return _c(
              "v-col",
              { key: "skeleton-" + index, attrs: { md: "4" } },
              [_c("CardSkeletonList")],
              1
            )
          })
        : [
            _vm._l(_vm.folders, function (folder, index) {
              return _c(
                "v-col",
                { key: index, attrs: { cols: "12", sm: "6", md: "3" } },
                [
                  _c("CardFolder", {
                    attrs: { folder: folder, legajo_id: _vm.legajo_id },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("open-folder", folder)
                      },
                      editItem: function ($event) {
                        return _vm.$emit("editItem", folder)
                      },
                      deleteItem: function ($event) {
                        return _vm.$emit("deleteItem", folder)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            !_vm.folders || _vm.folders.length === 0
              ? _c("v-col", { attrs: { cols: "12" } }, [_c("ListEmpty")], 1)
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }